import api, { getCsrfCookie } from './api';
import type {
  User,
  LoginCredentials,
  RegisterData,
  ForgotPasswordData,
  ResetPasswordData,
} from '../types';

export const authService = {
  async login(credentials: LoginCredentials): Promise<User> {
    await getCsrfCookie();
    const response = await api.post('/api/auth/login', credentials);
    return response.data.user;
  },

  async register(data: RegisterData): Promise<User> {
    await getCsrfCookie();
    const response = await api.post('/api/auth/register', data);
    return response.data.user;
  },

  async logout(): Promise<void> {
    await api.post('/api/auth/logout');
  },

  async getUser(): Promise<User> {
    const response = await api.get('/api/user');
    return response.data;
  },

  async resendVerificationEmail(): Promise<void> {
    await api.post('/api/email/resend');
  },

  async forgotPassword(data: ForgotPasswordData): Promise<void> {
    await getCsrfCookie();
    await api.post('/api/auth/forgot-password', data);
  },

  async resetPassword(data: ResetPasswordData): Promise<void> {
    await getCsrfCookie();
    await api.post('/api/auth/reset-password', data);
  },
};

export default authService;
